import { render, staticRenderFns } from "./PageEventsCategory.vue?vue&type=template&id=2d045776&"
import script from "./PageEventsCategory.vue?vue&type=script&lang=js&"
export * from "./PageEventsCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d045776')) {
      api.createRecord('2d045776', component.options)
    } else {
      api.reload('2d045776', component.options)
    }
    module.hot.accept("./PageEventsCategory.vue?vue&type=template&id=2d045776&", function () {
      api.rerender('2d045776', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/categories/PageEventsCategory.vue"
export default component.exports